import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import { DropdownButton, Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import {
  fetchAllTickets,
  fetchTickets,
  openTicketModal,
  editTicket,
  searchTicket,
  fetchSettings,
  checkTicketDaschoardStatus,
  updateSortedTicket,
  updateSetting,
} from "TicketAction";
import { fetchEventDetails, fetchUsersCategory } from "DashboardUserAction";
import { fetchFormBuilder } from "FormBuilderAction";
import {
  IMAGE_PATH,
  DEVELOPMENT_TYPE,
  screenHeightLeftFromTop,
} from "Constants";
import AddTicket from "./addticket";
import TicketItem from "./ticket-list-item";
import TicketUrl from "./ticket-url.js";
import AssociatedSessions from "./associated-sessions";
import ManageUsersGroup from "ManageUsersGroup";
import LocaleStrings from "Languages";
// const itemCount = 20;

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = { pageNumber: 1, search: "", pageLoader: false, sort: null };
    this.onSearchTicket = this.onSearchTicket.bind(this);
  }

  componentDidMount() {
    this.props.checkTicketDaschoardStatus(this.props.session);
    this.props.fetchAllTickets(this.props.session, (response) => {});
    this.props.fetchTickets(this.props.session, (response) => {});
    this.props.fetchSettings(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchFormBuilder(this.props.session, 0, (response) => {});
    this.props.fetchUsersCategory(this.props.session);
  }

  showEmailPreviewModal = (e) => {
    this.setState({ showEmailPreviewModal: true });
  };

  closeEmailPreviewModal = (e) => {
    this.setState({ showEmailPreviewModal: false });
  };

  openModal = (obj) => {
    // console.log(obj);

    this.setState({ loading: false });
    this.props.editTicket({});
    this.props.openTicketModal({ showModal: true, ...obj });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    // var arrAvailable = this.props.ticketList.resource;
    var arrAvailable = _.orderBy(
      this.props.ticketList.resource,
      "orderby",
      "asc"
    );
    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
    // console.log("arrAvailable", arrAvailable);
    var newArrAvailable = [];

    this.setState({ activeCount: arrAvailable.length });

    let plus = 1;
    // if (this.state.pageNumber > 1) {
    //   plus = itemCount * (this.state.pageNumber - 1) + 1;
    // }

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, orderby: index + plus });
    });
    // console.log("newArrAvailable", newArrAvailable);
    this.setState({ pageLoader: true });
    this.props.updateSortedTicket(
      this.props.session,
      newArrAvailable,
      (response) => {
        this.props.fetchTickets(this.props.session, (callback) => {
          this.setState({ pageLoader: false });
        });
      }
    );
  };

  onSearchTicket = (event) => {
    var search = event.target.value;
    let pageNumber = 1;
    if (search == "") {
      this.props.fetchTickets(this.props.session, (response) => {});
    } else {
      this.props.searchTicket(this.props.session, search, (response) => {});
    }
    this.setState({ search, pageNumber });
  };

  handleSortByName = (ev) => {
    var sort = ev.target.value;
    let values = {};
    values.id = this.props.settingInfo.resource[0].id;
    values.ticketsortby = sort;
    // console.log("values :- ", values);

    this.setState({ pageLoader: true, sort });
    this.props.updateSetting(values, this.props.session, (response) => {
      setTimeout(() => {
        if (response.success === 0) {
          this.setState({ pageLoader: false });
          // this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ pageLoader: false });
        }
      }, 1000);
    });
  };

  ticketAdditionCallback = () => {
    // after update call this method with page no. as param, it will display as your current search or sort rocord

    this.props.fetchAllTickets(this.props.session, (callback) => {});

    this.paginationCallback(this.state.pageNumber);
  };

  paginationCallback = (pageNumber) => {
    let { session } = this.props;
    let { search } = this.state;

    if (search == "") {
      this.props.fetchTickets(session, (response) => {});
    } else if (search != "") {
      this.props.searchTicket(session, search, (response) => {});
    }

    this.setState({ pageNumber });
  };

  renderTicketList() {
    let { pageNumber } = this.state;
    let { ticketList, settingInfo } = this.props;
    let pageDataLength = ticketList.resource.length;
    let sortby = "totalsoldtickets";
    let orderby = "desc";
    if (
      settingInfo &&
      settingInfo.resource &&
      settingInfo.resource.length > 0 &&
      settingInfo.resource[0].ticketsortby
    ) {
      sortby =
        settingInfo.resource[0].ticketsortby === "topsold"
          ? "totalsoldtickets"
          : settingInfo.resource[0].ticketsortby === "endingsoon"
          ? "saleenddate"
          : "orderby";

      orderby = sortby === "totalsoldtickets" ? "desc" : "asc";
    }

    let sortedByMaxSold = _.orderBy(ticketList.resource, sortby, orderby);

    return _.map(sortedByMaxSold, (ticket) => {
      return (
        <TicketItem
          key={ticket.id}
          ticket={ticket}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  }

  /**
   * =============================================================================================
   */

  render() {
    let {
      deviceSize,
      ticketList,
      settingInfo,
      eventDetails,
      showModal,
      showTicketUrlModal,
      ShowUserCategoryModal,
      ticketSesionModal,
    } = this.props;
    let { pageNumber, search, sort } = this.state;
    let pageDataLength = 0;
    let manualArr = [];

    let sortList = [
      { label: LocaleStrings.tickets_ticket_sort_option1, value: "manual" },
      { label: LocaleStrings.tickets_ticket_sort_option2, value: "topsold" },
      { label: LocaleStrings.tickets_ticket_sort_option3, value: "endingsoon" },
    ];

    if (
      ticketList &&
      ticketList.resource &&
      ticketList.resource.length > 0 &&
      (sort === "manual" ||
        (settingInfo &&
          settingInfo.resource &&
          settingInfo.resource.length > 0 &&
          settingInfo.resource[0].ticketsortby === "manual"))
    ) {
      manualArr = _.orderBy(ticketList.resource, "orderby", "asc");
      pageDataLength = ticketList.resource.length;
    }

    var classCustom = "";
    if (this.state.pageLoader) {
      classCustom = "gamification-page-loading";
    }

    const SortableItem = SortableElement(
      ({ ticket, pageDataLength, currentPage }) => (
        <div>
          <TicketItem
            key={ticket.id}
            ticket={ticket}
            pageDataLength={pageDataLength}
            currentPage={currentPage}
            pagination={this.paginationCallback}
            sortby={"manual"}
          />
        </div>
      )
    );

    const SortableList = SortableContainer(
      ({ collection, pageDataLength, currentPage, disabled }) => {
        return (
          <div>
            {collection.map((ticket, index) => {
              return (
                <SortableItem
                  key={`section-${index}`}
                  index={index}
                  ticket={ticket}
                  pageDataLength={pageDataLength}
                  currentPage={currentPage}
                  disabled={disabled}
                />
              );
            })}
          </div>
        );
      }
    );

    return (
      <div className="panel noborder-panel">
        {(ticketList &&
          ticketList.resource &&
          ticketList.resource.length > 0) ||
        search != "" ? (
          <div className="content-header-bar">
            {/* Left section */}
            <div>
              <div className="custom-text3-primary-medium">
                {LocaleStrings.tickets_ticket_title}
              </div>
              <div className="custom-text2-secondary-normal">
                <span className="text-danger">*</span>{" "}
                {LocaleStrings.tickets_ticket_note1}
              </div>
            </div>

            {/* Right section */}
            <ul className="header-buttons">
              <li className="pr-10">
                <select
                  className="form-control dropdown-height-border content-table-header-selectrandomly"
                  placeholder="Sort by"
                  onChange={this.handleSortByName}
                  value={
                    sort
                      ? sort
                      : settingInfo &&
                        settingInfo.resource &&
                        settingInfo.resource.length > 0
                      ? settingInfo.resource[0].ticketsortby
                      : ""
                  }
                >
                  {sortList.map((object, index) => {
                    return (
                      <option
                        key={`${object.value}-${index}`}
                        value={object.value}
                      >
                        {object.label}
                      </option>
                    );
                  })}
                </select>
              </li>
              <li>
                <input
                  className="form-control mapsearch"
                  placeholder={LocaleStrings.button_search}
                  type="text"
                  value={this.state.search}
                  onChange={this.onSearchTicket}
                />
              </li>
              <li>
                {DEVELOPMENT_TYPE === "koachify" ? (
                  <button
                    type="button"
                    className="btn btn-custom-blue"
                    onClick={(e) =>
                      this.openModal({
                        category: "attendee",
                        genre: "plan",
                      })
                    }
                  >
                    {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.button_new_plan} */}
                    <img
                      src="../../style/images/header-icons/plus.png"
                      style={{ paddingRight: 8, paddingBottom: 3 }}
                    ></img>
                    {LocaleStrings.button_new_plan}
                  </button>
                ) : (
                  <>
                    <div className="dropdown-btn-container">
                      <DropdownButton
                        className="dropdown-blue-btn"
                        title={LocaleStrings.button_new_ticket}
                        key="1"
                        id="dropdown-basic-2"
                        // nocaret
                      >
                        <Dropdown.Item
                          eventKey="attendee"
                          onClick={() =>
                            this.openModal({
                              category: "attendee",
                              genre: "general",
                            })
                          }
                        >
                          {LocaleStrings.tickets_add_ticket_option1}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="exhibitor"
                          onClick={() =>
                            this.openModal({
                              category: "exhibitor",
                              genre: "general",
                            })
                          }
                        >
                          {LocaleStrings.tickets_add_ticket_option2}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="sponsor"
                          onClick={() =>
                            this.openModal({
                              category: "sponsor",
                              genre: "general",
                            })
                          }
                        >
                          {LocaleStrings.tickets_add_ticket_option3}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="speaker"
                          onClick={() =>
                            this.openModal({
                              category: "speaker",
                              genre: "general",
                            })
                          }
                        >
                          {LocaleStrings.tickets_add_ticket_option4}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="addon"
                          onClick={() =>
                            this.openModal({
                              category: "addon",
                              genre: "addon",
                            })
                          }
                        >
                          {LocaleStrings.tickets_add_ticket_option5}
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                  </>
                )}
              </li>
            </ul>
          </div>
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          <p className="ticket-notehidden">
            <span className="text-danger">*</span>{" "}
            {LocaleStrings.tickets_ticket_note1}
          </p>
          {ticketList &&
          ticketList.resource &&
          ticketList.resource.length > 0 ? (
            <div className="">
              {sort === "manual" ||
              (settingInfo &&
                settingInfo.resource &&
                settingInfo.resource.length > 0 &&
                settingInfo.resource[0].ticketsortby === "manual") ? (
                <div>
                  <div
                    className="row mb-10"
                    style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
                  >
                    <div
                      className="col-md-4 col-sm-3"
                      style={{ paddingLeft: 58 }}
                    >
                      # {LocaleStrings.tickets_ticket_table_list_ticket_name}
                    </div>
                    <div
                      className="col-md-2 col-sm-2"
                      style={{ paddingLeft: 17 }}
                    >
                      {LocaleStrings.tickets_ticket_table_list_total}
                    </div>
                    <div
                      className="col-md-1 col-sm-2"
                      style={{ paddingLeft: 13 }}
                    >
                      {LocaleStrings.tickets_ticket_table_list_sold}
                    </div>
                    <div
                      className="col-md-1 col-sm-1"
                      style={{ paddingLeft: 10 }}
                    >
                      {LocaleStrings.tickets_ticket_table_list_available}
                    </div>
                    <div
                      className="col-md-1 col-sm-1"
                      style={{ paddingLeft: 10 }}
                    >
                      {LocaleStrings.tickets_ticket_table_list_price}
                    </div>
                    <div
                      className="col-md-3 col-sm-3"
                      style={{ paddingLeft: 48 }}
                    >
                      {LocaleStrings.tickets_ticket_table_list_action}
                    </div>
                  </div>
                  <div
                    className={`col-md-12 ${classCustom}`}
                    style={{
                      backgroundColor: "#ffffff",
                      backfaceVisibility: "hidden",
                      willChange: "transform",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      titleBarStyle: "hidden",
                    }}
                  >
                    <SortableList
                      useDragHandle
                      collection={manualArr}
                      onSortEnd={this.onSortEnd}
                      pageDataLength={pageDataLength}
                      currentPage={pageNumber}
                    />
                  </div>
                </div>
              ) : (
                <div
                  className={`col-md-12 ${classCustom}`}
                  style={{
                    backgroundColor: "#ffffff",
                    backfaceVisibility: "hidden",
                    willChange: "transform",
                    userSelect: "none",
                    WebkitUserSelect: "none",
                    titleBarStyle: "hidden",
                  }}
                >
                  <table className="table ticketTable">
                    <thead>
                      <tr>
                        <th>
                          #{" "}
                          {LocaleStrings.tickets_ticket_table_list_ticket_name}
                        </th>
                        <th>{LocaleStrings.tickets_ticket_table_list_total}</th>
                        <th>{LocaleStrings.tickets_ticket_table_list_sold}</th>
                        <th>
                          {LocaleStrings.tickets_ticket_table_list_available}
                        </th>
                        <th>{LocaleStrings.tickets_ticket_table_list_price}</th>
                        <th style={{ paddingLeft: 90 }}>
                          {LocaleStrings.tickets_ticket_table_list_action}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderTicketList()}
                    </tbody>
                  </table>
                </div>
              )}
              {/* {ticketList && ticketList.count > itemCount ? (
                <Pagination
                  activePage={this.state.pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={ticketList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )} */}
            </div>
          ) : this.state.search != "" ? (
            <div className="no-content-container">
              <div>
                <div>
                  <img src={IMAGE_PATH + "/ticket-icons/noticket.png"} />
                </div>
                <div className="no-content-message">
                  {LocaleStrings.tickets_ticket_text_no_ticket_found}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-content-container">
              <div>
                <div>
                  <img src={IMAGE_PATH + "/ticket-icons/noticket.png"} />
                </div>
                <div className="no-content-message">
                  {LocaleStrings.tickets_ticket_text_no_tickets}
                </div>
                <div className="no-content-message">
                  {LocaleStrings.tickets_ticket_text_create_ultimate_ticket}
                </div>
                <div style={{ padding: 20, textAlign: "center" }}>
                  {DEVELOPMENT_TYPE === "koachify" ? (
                    <button
                      type="button"
                      className="btn btn-custom-blue"
                      onClick={(e) =>
                        this.openModal({
                          category: "attendee",
                          genre: "plan",
                        })
                      }
                    >
                      {LocaleStrings.button_new_plan}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-custom-blue"
                      onClick={(e) =>
                        this.openModal({
                          category: "attendee",
                          genre: "general",
                        })
                      }
                    >
                      {LocaleStrings.button_create_new}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {showModal &&
          showModal.showModal &&
          settingInfo &&
          settingInfo.resource ? (
            <AddTicket
              history={this.props.history}
              settingInfo={settingInfo}
              finishOperationsCallback={this.ticketAdditionCallback}
            />
          ) : (
            ""
          )}
          {showTicketUrlModal.showModal ? (
            <TicketUrl eventDetails={eventDetails} />
          ) : (
            ""
          )}
          {ShowUserCategoryModal ? (
            <ManageUsersGroup
              finishOperationsCallback={this.ticketAdditionCallback}
            />
          ) : null}
          {ticketSesionModal && ticketSesionModal.showModal ? (
            <AssociatedSessions ticketSesionModal={ticketSesionModal} />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ticketMenus: state.ticketMenus,
    session: state.session,
    showModal: state.showTicketModal,
    showTicketUrlModal: state.showTicketUrlModal,
    ticketList: state.TicketList,
    settingInfo: state.SettingData,
    eventDetails: state.userEventDetails,
    ShowUserCategoryModal: state.ShowDashboardUserCategoryModal,
    deviceSize: state.deviceSize,
    ticketSesionModal: state.ticketSesionModal,
  };
}

export default connect(mapStateToProps, {
  fetchAllTickets,
  fetchTickets,
  openTicketModal,
  editTicket,
  searchTicket,
  fetchSettings,
  fetchEventDetails,
  fetchFormBuilder,
  checkTicketDaschoardStatus,
  fetchUsersCategory,
  updateSortedTicket,
  updateSetting,
})(Ticket);
